import React from 'react';
import PropTypes from 'prop-types';

import { getAssetUrl } from 'editor-utils/template';

import withPlaceholderStyle from '.';

const StaticPlaceholder = ({ style, ...props }) => {
  if (props.placeholder.src) {
    const backgroundImage = `url("${getAssetUrl(
      props.template,
      `/assets_client/images/${props.placeholder.src}?_`,
    )}")`;
    const backgroundSize = 'contain';
    const backgroundPosition = '50% 50%';
    const backgroundRepeat = 'no-repeat';

    return (
      <div
        style={{ ...style, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat }}
        className="editor-placeholder"
      />
    );
  }

  return null;
};

StaticPlaceholder.propTypes = {
  style: PropTypes.object.isRequired,
  placeholder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
};

export default withPlaceholderStyle(StaticPlaceholder);
